import React from 'react';
import { CONFIG } from 'config/config';


import CircularProgress from '@material-ui/core/CircularProgress';
import { Text, View } from '@coinscrap/webapp-core';


export const RegularLoader = ({ loadingText }) => {
	return (
		<View rowSt justifyStartSt marginLeftMdSt marginTopLgSt>
			<CircularProgress
				style={{
					width: 35,
					height: 35,
					marginRight: 20,
					color: CONFIG.colors.primary,
				}}
			/>
			<Text>{loadingText}</Text>
		</View>
	);
};
